var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlank = function SvgBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#41D9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.268 12.876a268.378 268.378 0 0 0 .085 17.035c.018.49.433.915.924.943a138 138 0 0 0 12.761.123.97.97 0 0 0 .914-.937 399.23 399.23 0 0 0 .059-17.258.956.956 0 0 0-.918-.928c-4.3-.117-8.6-.086-12.9.092a.977.977 0 0 0-.925.93Z",
    fill: "url(#blank_svg__a)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.056 10.02a251.991 251.991 0 0 0 0 17.547.894.894 0 0 0 .821.843c1.762.103 3.524.164 5.286.183a2.312 2.312 0 0 0 1.683-.709 2.489 2.489 0 0 0 .708-1.727c.004-.993.008-1.985.01-2.978a.819.819 0 0 1 .813-.816 316.2 316.2 0 0 0 2.97-.033 2.516 2.516 0 0 0 1.725-.731 2.4 2.4 0 0 0 .726-1.695c.015-3.294-.036-6.589-.15-9.883a.893.893 0 0 0-.822-.842 110.5 110.5 0 0 0-12.949 0 .894.894 0 0 0-.821.842Z",
    fill: "url(#blank_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.21 21.783c-.671-.032-3.98-.663-3.982-.668-1.088-.187-1.996.767-1.859 1.866.001 0 .385 3.318.431 3.993.033.459-.106.89-.334 1.259a2.49 2.49 0 0 0 1.137-2.076c.005-.993.008-1.985.01-2.978a.819.819 0 0 1 .813-.816c.99-.006 1.98-.017 2.97-.033a2.514 2.514 0 0 0 1.698-.706 1.992 1.992 0 0 1-.883.159Z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.47 28.207-.01.014.023-.022-.013.008Zm.684-.678c.263-.393.42-.868.423-1.378.004-.992.008-1.985.01-2.977a.819.819 0 0 1 .812-.816c.99-.007 1.98-.018 2.97-.033a2.51 2.51 0 0 0 1.635-.647l-5.85 5.85Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blank_svg__a",
    x1: 3.631,
    y1: 36.442,
    x2: 24.106,
    y2: 15.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blank_svg__b",
    x1: 22.491,
    y1: 28.015,
    x2: 14.326,
    y2: 8.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};

export default SvgBlank;